export const calculatedPromotionResultReducer = (state = [], action) => {
    switch (action.type) {
        case 'ADD_CALCULATED_PROMOTION_RESULT':
            return state.concat(action.payload)
        case 'RESET_CALCULATED_PROMOTION_RESULT':
            return []
        default:
            return state
    }
};